"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrInvalidTxSignReturnValue = exports.Err = void 0;
/**
 * The base class for exceptions (errors).
 */
class Err extends Error {
    constructor(message, inner) {
        super(message);
        this.inner = undefined;
        this.inner = inner;
    }
}
exports.Err = Err;
/**
 * Signals that the data inside the url is not a valid one for a transaction sign response
 */
class ErrInvalidTxSignReturnValue extends Err {
    constructor() {
        super("Invalid response in transaction sign return url");
    }
}
exports.ErrInvalidTxSignReturnValue = ErrInvalidTxSignReturnValue;
//# sourceMappingURL=errors.js.map